// src/store.ts
import { configureStore } from "@reduxjs/toolkit";
import blockedWordsSlice from "../Options/BlockedWords/blockedWordsSlice";
import blockedSellersSlice from "../Options/BlockedSellers//blockedSellersSlice";
import favoriteItemsSlice from "./FavoriteItems/favoriteItemsSlice";
import itemTableSlice from "../../ItemGrid/moduls/ItemSlice"

export const store = configureStore({
  reducer: {
    blockedWords: blockedWordsSlice,
    blockedSellers: blockedSellersSlice,
    favoriteItems: favoriteItemsSlice,
    itemsTable: itemTableSlice
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
